import * as React from 'react';
import { FC } from 'react';
import classnames from 'classnames';
import { moneyAccurate as money } from 'app/helpers/money';
import { useContext } from './useFormContext';

const BalanceUsage: FC<{
  balance: number;
  isBalanceViolated: boolean;
}> = ({ balance, isBalanceViolated }) => {
  const context = useContext();
  const { isDeposit, locales, currency } = context;

  if (isDeposit) return null;

  return (
    <div className="balance-usage">
      <div id="balance-usage-label">{`${locales.balance_usage_label}:`}</div>
      <div aria-labelledby="balance-usage-label" className={classnames({ error: isBalanceViolated }, 'value')}>
        {money(+balance, currency)}
      </div>
    </div>
  );
};

export default BalanceUsage;
